import { type TransactionHash, TRANSACTION_TYPES, EVENT_SUFFIXES } from "@/types";
import { createEventEmitter } from "@/events";

export const WITHDRAW_UNWOUND_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.WITHDRAW_UNWOUND}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface WithdrawUnwoundSuccessPayload {
    transactionHash: TransactionHash;
    unwindingTimestamp: number;
}

export interface WithdrawUnwoundEventPayloads extends Record<string, unknown> {
    [WITHDRAW_UNWOUND_EVENTS.SUCCESS]: WithdrawUnwoundSuccessPayload;
}

export const withdrawUnwoundEventEmitter = createEventEmitter<WithdrawUnwoundEventPayloads>();
